import { useTranslation } from 'react-i18next';

interface LanguageSwitcherProps {
  className?: string;
}

export function LanguageSwitcher({ className = '' }: LanguageSwitcherProps) {
  const { i18n } = useTranslation();
  // i18n.language can be 'ko-KR', 'ko', 'en-US', 'en', etc.
  const isKorean = i18n.language?.startsWith('ko') ?? false;

  const toggleLanguage = () => {
    i18n.changeLanguage(isKorean ? 'en' : 'ko');
  };

  return (
    <button
      onClick={toggleLanguage}
      className={`flex items-center rounded-full bg-white/5 border border-white/10 p-0.5 hover:bg-white/10 transition-all cursor-pointer ${className}`}
      title={isKorean ? 'Switch to English' : '한국어로 전환'}
    >
      <span
        className={`px-2.5 py-1 rounded-full text-xs font-medium transition-all ${
          isKorean
            ? 'bg-white/15 text-white'
            : 'text-white/40'
        }`}
      >
        한
      </span>
      <span
        className={`px-2.5 py-1 rounded-full text-xs font-medium transition-all ${
          !isKorean
            ? 'bg-white/15 text-white'
            : 'text-white/40'
        }`}
      >
        EN
      </span>
    </button>
  );
}
